import React from "react"
import { Box } from "@mui/material"
import PropTypes from "prop-types"

const TabContent = ({children, value, index}) => {
    return (
        <Box
            role="tabcontent"
            hidden={value !== index}
            id={`tabcontent-${index}`}
            aria-labelledby={`tab-${index}`}
            mt={2}
        >
            {value === index && children}
        </Box>
    )
}

export default TabContent